import { environmentService, postRequestHandler, getRequestHandler } from '@/utils/services';
import { ToastProgrammatic as Toast, DialogProgrammatic as Dialog } from 'buefy';

import axios from 'axios';

const DefaultState = () => {
  return {
    integrationComponent:false,
    channels:[],
    hotels:[],
    distantisHotels:[],
    cangoorooHotels: [],
    mappingHotels: [],
    hotelsRefresh:false,
    distantisRefresh: false,
    cangoorooRefresh: false,
    mappingRefresh: false,
    selectedChannel:{},
    apiUrl:null,
    apiUrlHotel:null,
    apiUrlIntegration:null,
    openIntegrationQuickview:false,
    toggleQuickview:false,
  };
},
      state = DefaultState(),
      getters = {
        channels: state => state.channels,
        hotels: state => state.hotels,
        hotelsRefresh: state => state.hotelsRefresh,
        selectedChannel: state => state.selectedChannel,
        integrationComponent: state => state.integrationComponent,
        distantisHotels: state => state.distantisHotels,
        cangoorooHotels: state => state.cangoorooHotels,
        mappingHotels: state => state.mappingHotels,
        distantisRefresh: state => state.distantisRefresh,
        cangoorooRefresh: state => state.cangoorooRefresh,
        mappingRefresh: state => state.mappingRefresh,
        openIntegrationQuickview: state => state.openIntegrationQuickview,
        toggleQuickview: state => state.toggleQuickview
      },
      mutations = {
        setUrls() {
          state.apiUrl = environmentService.apiUrlUser;
          state.apiUrlHotel = environmentService.apiUrlHotel;
          state.apiUrlIntegration = environmentService.apiUrlIntegration;
        },
        setChannels(state, payload) {
          state.channels=payload;
        },
        setHotels(state, payload) {
          state.hotels=payload;
        },
        setSelectedChannel(state, payload){
          state.selectedChannel = payload;
        },
        setIntegrationComponent(state, payload){
          state.integrationComponent = payload;
        },
        setHotelsRefresh(state, payload){
          state.hotelsRefresh = payload;
        },
        setDistantisHotels(state, payload){
          state.distantisHotels = payload;
        },
        setCangoorooHotels(state, payload){
          state.cangoorooHotels = payload;
        },
        setMappingHotels(state, payload){
          state.mappingHotels = payload;
        },
        setDistantisRefresh(state, payload){
          state.distantisRefresh = payload;
        },
        setCangoorooRefresh(state, payload){
          state.cangoorooRefresh = payload;
        },
        setMappingRefresh(state, payload){
          state.mappingRefresh = payload;
        },
        setIntegrationQuickview(state, payload){
          state.openIntegrationQuickview = payload;
        },
        setToggleQuickview(state, payload){
          state.toggleQuickview = payload;
        }
      },
      actions = {
        async getChannels({commit,  rootState}) {
          commit('setUrls');
          let channels = await getRequestHandler(`${state.apiUrl}/channels`, {
            headers: rootState.auth.headers
          });
          commit('setChannels', channels);
        },
        setIntegrationQuickview({commit}, payload) {
          commit('setIntegrationQuickview', payload);
        },
        setToggleQuickview({commit}, payload) {
          commit('setToggleQuickview', payload);
        },
        async getHotels({commit,  rootState}) {
          let hotels = await getRequestHandler(`${state.apiUrlHotel}/hotels/integration/available`, {
            headers: rootState.auth.headers
          });
          commit('setHotels', hotels)
        },

        async setUrls({commit}){
          await commit('setUrls');
        },
        setDistantisRefresh({commit}, payload){
          commit('setDistantisRefresh', payload)
        },

        setCangoorooRefresh({commit}, payload){
          commit('setCangoorooRefresh', payload)
        },

        setMappingRefresh({commit}, payload){
          commit('setMappingRefresh', payload)
        },

        setHotelsRefresh({commit}, payload) {
          commit('setHotelsRefresh', payload);
        },

        async setSelectedChannel({commit}, payload) {
          await commit('setSelectedChannel', payload);
        },

        setIntegrationComponent({commit}, payload) {
          commit('setIntegrationComponent', payload);
        },

        async updateHotelConnection({commit, dispatch, state, rootState}, payload) {
          const data = {
            hotelId: payload.hotel.id,
            channelId: payload.update ? payload.hotel.channel_id : null
          };
          axios.post(`${state.apiUrlHotel}/hotels/integration/update`, data, { headers: rootState.auth.headers }).then(async response => {
            await dispatch('getHotels');
            commit('setHotelsRefresh', true);
            dispatch('global/setToastNotification',{title: 'Integrations', text: 'Integration updated', type:'success'}, {root: true})
          }).catch(error => {});
        },

        async getDistantisHotels({commit, state, rootState}) {
          await axios.get(`${state.apiUrlHotel}/hotels/integration/distantis/hotels`, { headers: rootState.auth.headers }).then(async response => {
            if (response.data.status == 200) {
              await commit('setDistantisHotels', response.data.data);
              commit('setDistantisRefresh', true)
            } else {
              dispatch('global/setToastNotification',{title: 'Integrations', text: 'Integration failed, please try again.', type:'danger'}, {root: true})
            }
          }).catch(error => {})
        },

        async updateDistantisIntegration({commit, dispatch, state, rootState}, payload) {

          if (payload.operation=='sync') {
            dispatch('global/setToastNotification',{title: 'Integrations', text: 'Preparing to sync', type:'success'}, {root: true})
            let result = await postRequestHandler(`${state.apiUrlHotel}/hotels/integration/distantis/filter`, {hotelId:payload.hotelId}, { headers: rootState.auth.headers })

            if (result.status == 200) {
              dispatch('global/setDialogNotification', {title: 'Integrations', text: `<strong>${result.data.count}</strong> inventory records will be sent to Distantis`, type: 'danger'}, {root: true})
                .then(res => {
                  dispatch('mapDistantisData', payload);
                  dispatch('global/setToastNotification',{title: 'Integrations', text: 'Task is running in background, it may take a while.', type:'success'}, {root: true})
                })
                .catch(error => {});
            }

            if (result.status == 204) {
              dispatch('global/setDialogAlert',{title: 'Integrations', text: 'No inventory found for the current hotel.', type:'danger'}, {root: true});
              commit('setDistantisRefresh', true);
            }

            if (result.status == 404) {
              dispatch('global/setToastNotification',{title: 'Integrations', text: 'Filter failed, please try again.', type:'danger'}, {root: true})
              commit('setDistantisRefresh', true);
            }

          } else {
            let result = await postRequestHandler(`${state.apiUrlHotel}/hotels/integration/distantis/update`, payload, { headers: rootState.auth.headers })
            if (result.status == 200){
              await dispatch('getDistantisHotels');
              dispatch('global/setToastNotification',{title: 'Integrations', text: 'Distantis integration updated', type:'success'}, {root: true})
            } else {
              dispatch('global/setToastNotification',{title: 'Integrations', text: 'Integration failed, please try again.', type:'danger'}, {root: true})
            }
          }
        },

        async getCangoorooHotels({commit, state, rootState}) {
          await axios.get(`${state.apiUrlHotel}/hotels/integration/cangooroo/hotels`, { headers: rootState.auth.headers }).then(async response => {
            if (response.data.status == 200) {
              await commit('setCangoorooHotels', response.data.data);
              commit('setCangoorooRefresh', true)
            } else {
              dispatch('global/setToastNotification',{title: 'Integrations', text: 'Integration failed, please try again.', type:'danger'}, {root: true})
            }
          }).catch(error => {})
        },

        async updateCangoorooIntegration({commit, dispatch, state, rootState}, payload) {
          let result = await postRequestHandler(`${state.apiUrlHotel}/hotels/integration/cangooroo/update`, payload, { headers: rootState.auth.headers })
          if (result.status == 200){
            await dispatch('getCangoorooHotels');
            dispatch('global/setToastNotification',{title: 'Integrations', text: 'Cangooroo integration updated', type:'success'}, {root: true})
          } else {
            dispatch('global/setToastNotification',{title: 'Integrations', text: 'Integration failed, please try again.', type:'danger'}, {root: true})
          }
        },

        async getMappingHotels({commit, state, rootState, dispatch}) {
          await axios.get(`${state.apiUrlHotel}/hotels/integration/mapping/hotels`, { headers: rootState.auth.headers }).then(async response => {
            if (response.data.status == 200) {
              await commit('setMappingHotels', response.data.data);
              commit('setMappingRefresh', true)
            } else {
              dispatch('global/setToastNotification',{title: 'Integrations', text: 'Integration failed, please try again.', type:'danger'}, {root: true})
            }
          }).catch(error => {})
        },

        async updateMappingHotels({commit, dispatch, state, rootState}, payload) {
          let result = await postRequestHandler(`${state.apiUrlHotel}/hotels/integration/mapping/update`, payload, { headers: rootState.auth.headers })
          if (result.status == 200){
            await dispatch('getMappingHotels');
            dispatch('global/setToastNotification',{title: 'Integrations', text: 'Mapping updated', type:'success'}, {root: true})
          } else {
            dispatch('global/setToastNotification',{title: 'Integrations', text: 'Integration failed, please try again.', type:'danger'}, {root: true})
          }
        },

        async createChannel({commit, dispatch, state, rootState}, payload) {
          await axios.post(`${state.apiUrl}/channels/create`, payload, { headers: rootState.auth.headers })
                     .then(response=>{
                       if (response.data.status == 200) {
                         commit('setToggleQuickview', true);
                         dispatch('getChannels');
                         dispatch('global/setToastNotification',{title: 'Integrations', text: 'Channel updated', type:'success'}, {root: true})
                       } else {
                         dispatch('global/setToastNotification',{title: 'Integrations', text: response.data.errors[0], type:'danger'}, {root: true})
                       }
                     })
                     .catch(error => {console.log(error)})
        },

        async updateChannel({commit, dispatch, state, rootState}, payload) {
          await axios.post(`${state.apiUrl}/channels/update`, payload, { headers: rootState.auth.headers })
                     .then(response=>{
                       if (response.data.status == 200) {
                         commit('setToggleQuickview', true);
                         dispatch('getChannels');
                         dispatch('global/setToastNotification',{title: 'Integrations', text: 'Channel updated', type:'success'}, {root: true})
                       } else {
                         dispatch('global/setToastNotification',{title: 'Integrations', text: response.data.errors[0], type:'danger'}, {root: true})
                       }
                     })
                     .catch(error => {console.log(error)})
        },

        mapDistantisData({commit, dispatch, state, rootState}, payload) {
          axios.defaults.timeout = 1000 * 60;
          axios.post(`${state.apiUrlIntegration}/distantis/map`, payload, {headers: rootState.auth.headers})
               .then(response => {})
               .catch(error => {
                 dispatch('global/setToastNotification',{title: 'Integrations', text: 'Task still in progress, you will be notified by E-mail when it ends.', type:'success'}, {root: true})
               })
        }
      };

export default {
  namespaced:true,
  state,getters,mutations,actions
};



// WEBPACK FOOTER //
// ./src/store/modules/integrations.js